<template>
  <div class="vx-row">
    <div class="vx-col w-full">
      <vs-card>
        <div slot="header">
          <div class="vx-row flex justify-between items-center m-2">
            <h3 class>Riwayat Kunjungan</h3>
          </div>
        </div>
        <div class="flex flex-col">
          <div class="w-full md:w-1/2 lg:w-1/3 self-end">
            <vx-input-group
              class="mb-6"
              prependClasses="border border-solid border-grey border-r-0 text-primary"
            >
              <template slot="prepend">
                <div class="prepend-text text-dark">
                  <span>
                    <vs-icon icon-pack="feather" icon="icon-calendar" />
                  </span>
                </div>
              </template>
              <datepicker v-model="date" :format="'yyyy-MM-dd'" />
            </vx-input-group>
          </div>
          <vs-table :data="histories">
            <template slot="thead">
              <vs-th>No.</vs-th>
              <vs-th>Tgl</vs-th>
              <vs-th>Jumlah Kunjungan</vs-th>
              <vs-th>Action</vs-th>
            </template>
            <template slot-scope="{data}">
              <vs-tr :data="tr" :key="indextr++" v-for="(tr, indextr) in data">
                <vs-td :data="indextr">{{ indextr }}</vs-td>
                <vs-td :data="tr.tgl">{{ tr.date }}</vs-td>
                <vs-td :data="tr.jumlah">{{ tr.total }}</vs-td>
                <vs-td>
                  <div class="vx-row flex-col w-1/4 md:w-1/4 lg:w-1/4">
                    <vs-button
                      @click="$router.push({name: 'riwayat-detail', params: {date: tr.date}})"
                      type="border"
                      color="primary"
                      size="small"
                      icon-pack="feather"
                      icon="icon-eye"
                    >Detail</vs-button>
                  </div>
                </vs-td>
              </vs-tr>
            </template>
          </vs-table>
        </div>
      </vs-card>
    </div>
  </div>
</template>

<script>
import Datepicker from "vuejs-datepicker";
import moment from "moment";

export default {
  data() {
    return {
      histories: [],
      date: ""
    };
  },
  components: {
    Datepicker
  },
  mounted() {
    this.init();
  },
  methods: {
    init() {
      this.$vs.loading();
      this.$http
        .get(
          `/app/secure/history?date=${
            this.date ? this.formatterDate(this.date) : ""
          }`
        )
        .then(r => {
          this.histories = r.data.data.histories;
        })
        .catch(e => {
          this.parseError(e);
        })
        .finally(() => {
          this.$vs.loading.close();
        });
    },
    formatterDate(date) {
      return moment(date).format("YYYY-MM-DD");
    }
  },
  watch: {
    date() {
      this.init();
    }
  }
};
</script>>